export type ChangePasswordDto = {
  currentPassword: any;
  newPassword: string;
  confirmPassword: string;
};

export const ChangePasswordDefault: ChangePasswordDto = {
  currentPassword: "",
  newPassword: "",
  confirmPassword: ""
};